<template>
  <span>    
    <my-login></my-login>    
  </span>
</template>

<script>
import MyLogin from "@/components/Auth/Login";

export default {
  name: "Login",
  components: {    
    MyLogin
  }
};
</script>

<style scoped> 

</style>


// WEBPACK FOOTER //
// Login.vue?05fa6711